import { render } from "./UpdateSignedCertificate.vue?vue&type=template&id=dce3122e&scoped=true"
import script from "./UpdateSignedCertificate.vue?vue&type=script&lang=js"
export * from "./UpdateSignedCertificate.vue?vue&type=script&lang=js"

import "./UpdateSignedCertificate.vue?vue&type=style&index=0&id=dce3122e&lang=scss&scoped=true"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce3122e"]])

export default __exports__